var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.354 14.3999C18.1818 14.4616 17.0749 13.8782 16.5 12.8956C16.4474 12.8187 16.3533 12.7777 16.2584 12.7905C16.1634 12.8032 16.0846 12.8673 16.056 12.9551L14.48 17.7686C14.2513 18.3547 13.6624 18.7388 13.0105 18.7269C12.3586 18.715 11.7854 18.3098 11.58 17.7158L9.256 9.40793C9.22634 9.30155 9.12507 9.2282 9.01038 9.23001C8.89568 9.23183 8.79699 9.30835 8.771 9.41561C8.54242 10.6634 8.13875 11.8757 7.571 13.0194C7.03427 13.95 5.97792 14.4907 4.874 14.3999H0.167999C1.14434 19.9423 6.14472 23.999 12 23.999C17.8553 23.999 22.8557 19.9423 23.832 14.3999H19.354Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.874 12.4799C5.809 12.4799 5.886 12.4799 6.787 9.05754C6.993 8.27706 7.235 7.35738 7.542 6.27834C7.73902 5.66878 8.33549 5.26033 9 5.27994C9.66529 5.26195 10.2608 5.67363 10.454 6.28506L12.854 14.8559C12.8821 14.9594 12.9784 15.0323 13.0897 15.0345C13.201 15.0367 13.3004 14.9677 13.333 14.8655L14.679 10.7519C14.881 10.1986 15.4166 9.82142 16.027 9.8025C16.6175 9.75909 17.1805 10.0486 17.47 10.5446C17.57 10.7308 17.67 10.9123 17.755 11.087C18.336 12.2111 18.505 12.4771 19.355 12.4771H24C23.9992 6.11474 18.6259 0.957701 11.9985 0.958496C5.37108 0.959291 -0.000828427 6.11762 0 12.4799H4.874Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.684bc947.svg";
export { ForwardRef as ReactComponent };